import {
  ROUTE_NAME_ORDER_LOGIN,
  ROUTE_NAME_ORDER_MANAGEMENT,
  ROUTE_NAME_ORDER_DELIVERY,
  ROUTE_NAME_ORDER_COLLECTING,
  ROUTE_NAME_TASKS_ORDER,
  ROUTE_NAME_TASKS_PRODUCT,
  ROUTE_NAME_DELIVERY_COURIER,
  ROUTE_NAME_ADMIN_STATS
} from '@/constants/routes'
import {
  USER_ROLE_GUEST,
  USER_ROLE_CALL_CENTER,
  USER_ROLE_LOGISTICIAN,
  USER_ROLE_SUPER_LOGISTICIAN,
  USER_ROLE_COLLECTOR,
  USER_ROLE_COLD_COOKER,
  USER_ROLE_COLD_CUTTER,
  USER_ROLE_HOT_COOKER,
  USER_ROLE_PIZZA_DOUGH,
  USER_ROLE_PIZZA_COOKER,
  USER_ROLE_PIZZA_COLLECTOR,
  USER_ROLE_DELIVERY_COURIER,
  USER_ROLE_ADMIN
} from '@/constants/roles'
import {USER_ROLE_ACCOUNTING_WORKERS, USER_ROLE_WORKSHOPS_OVERALL} from './roles'
import {ROUTE_NAME_ACCOUNTING_WORKERS, ROUTE_NAME_WORKSHOP_STATS} from './routes'

const ALL_PERMISSIONS = [
  {
    role: USER_ROLE_GUEST,
    access: false,
    redirect: ROUTE_NAME_ORDER_LOGIN
  },
  {
    role: USER_ROLE_CALL_CENTER,
    access: false,
    redirect: ROUTE_NAME_ORDER_MANAGEMENT
  },
  {
    role: USER_ROLE_LOGISTICIAN,
    access: false,
    redirect: ROUTE_NAME_ORDER_DELIVERY
  },
  {
    role: USER_ROLE_SUPER_LOGISTICIAN,
    access: false,
    redirect: ROUTE_NAME_ORDER_DELIVERY
  },
  {
    role: USER_ROLE_COLLECTOR,
    access: false,
    redirect: ROUTE_NAME_ORDER_COLLECTING
  },
  {
    role: USER_ROLE_COLD_COOKER,
    access: false,
    redirect: ROUTE_NAME_TASKS_ORDER
  },
  {
    role: USER_ROLE_COLD_CUTTER,
    access: false,
    redirect: ROUTE_NAME_TASKS_ORDER
  },
  {
    role: USER_ROLE_HOT_COOKER,
    access: false,
    redirect: ROUTE_NAME_TASKS_ORDER
  },
  {
    role: USER_ROLE_PIZZA_DOUGH,
    access: false,
    redirect: ROUTE_NAME_TASKS_PRODUCT
  },
  {
    role: USER_ROLE_PIZZA_COOKER,
    access: false,
    redirect: ROUTE_NAME_TASKS_ORDER
  },
  {
    role: USER_ROLE_PIZZA_COLLECTOR,
    access: false,
    redirect: ROUTE_NAME_TASKS_ORDER
  },
  {
    role: USER_ROLE_DELIVERY_COURIER,
    access: false,
    redirect: ROUTE_NAME_DELIVERY_COURIER
  },
  {
    role: USER_ROLE_DELIVERY_COURIER,
    access: false,
    redirect: ROUTE_NAME_DELIVERY_COURIER
  },
  {
    role: USER_ROLE_ADMIN,
    access: false,
    redirect: ROUTE_NAME_ADMIN_STATS
  },
  {
    role: USER_ROLE_ACCOUNTING_WORKERS,
    access: false,
    redirect: ROUTE_NAME_ACCOUNTING_WORKERS
  },
  {
    role: USER_ROLE_WORKSHOPS_OVERALL,
    access: false,
    redirect: ROUTE_NAME_WORKSHOP_STATS
  }
]

export function permExclude (routeName) {
  return ALL_PERMISSIONS.filter(el => {
    return el.redirect !== routeName
  })
}

export function permExcludeRole (roleName) {
  return ALL_PERMISSIONS.filter(el => {
    return el.role !== roleName
  })
}



// WEBPACK FOOTER //
// ./src/constants/permissions.js